import type { SortOption } from "../../Common/controls/MobileSortBottomSheet";
import type { ReturnedTranslatedContentClientsPageHook } from "../../types";

import { useIsMobile } from "../../../hooks";
import { Typo } from "../../../Typo";
import { MobileSortBottomSheet } from "../../Common/controls/MobileSortBottomSheet";
import { useClientTradingReportContext } from "../providers/TradingReportProvider";

type ClientTradingReportSortProps = {
  isMobileBottomSheetEnable: boolean;
  translations: ReturnedTranslatedContentClientsPageHook;
};

export const ClientTradingReportSort = ({
  isMobileBottomSheetEnable,
  translations,
}: ClientTradingReportSortProps) => {
  const {
    state: { sortBy, sortOrder },
    actions: { setSort },
    runResource,
  } = useClientTradingReportContext();
  const isMobile = useIsMobile();

  const { tradingColumnLabels } =
    translations.translatedContent.tradingReportTab;
  const sortOptions: SortOption[] = [
    { id: "totalVolumeUSD", label: tradingColumnLabels.totalVolume },
    { id: "totalEarnings", label: tradingColumnLabels.totalEarnings },
    { id: "volumeFX", label: tradingColumnLabels.colVolFx },
    { id: "volumeXAU", label: tradingColumnLabels.colVolXau },
  ];

  if (!isMobileBottomSheetEnable || !isMobile) {
    return null;
  }

  return (
    <div className="sticky top-[136px] z-10 -mb-4 mt-4 bg-surface-primary pb-2">
      <div className="flex h-10 items-center gap-6">
        <div className="min-w-0 flex-1">
          <MobileSortBottomSheet
            sortOptions={sortOptions}
            selectedSortBy={sortBy ?? "totalEarnings"}
            selectedSortOrder={sortOrder ?? "desc"}
            onApply={(newSortBy, newSortOrder) =>
              setSort(newSortBy, newSortOrder)
            }
          />
        </div>
        <div className="flex shrink-0 flex-row items-center">
          <button
            onClick={() => runResource("csv")}
            className="flex h-10 cursor-pointer items-center justify-center rounded-lg bg-surface-tonal-default px-3 py-2"
          >
            <Typo type="labelSM">
              {translations.translatedContent.exportCSVText}
            </Typo>
          </button>
        </div>
      </div>
    </div>
  );
};
